import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Box,
  Flex,
} from '@chakra-ui/react';
import Button from 'components/ui/Button';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: React.ReactNode;
  children: React.ReactNode;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl' | 'full';
  primaryBtnLabel?: string;
  secondaryBtnLabel?: string;
  onPrimaryClick?: () => void;
  onSecondaryClick?: () => void;
  primaryBtnLoading?: boolean;
  secondaryBtnLoading?: boolean;
  primaryBtnDisabled?: boolean;
  secondaryBtnDisabled?: boolean;
  hideFooter?: boolean;
  closeOnOverlayClick?: boolean;
  headerExtra?: React.ReactNode;
  scrollBehavior?: 'inside' | 'outside';
}

export default function CustomModal({
  isOpen,
  onClose,
  title,
  children,
  size = 'md',
  primaryBtnLabel = 'Guardar',
  secondaryBtnLabel = 'Cancelar',
  onPrimaryClick,
  onSecondaryClick,
  primaryBtnLoading = false,
  secondaryBtnLoading = false,
  primaryBtnDisabled = false,
  secondaryBtnDisabled = false,
  hideFooter = false,
  closeOnOverlayClick = true,
  headerExtra,
  scrollBehavior = 'outside',
}: ModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size={size}
      closeOnOverlayClick={closeOnOverlayClick}
      scrollBehavior={scrollBehavior}
      isCentered
      blockScrollOnMount={false}
    >
      <ModalOverlay backdropFilter="blur(4px)" />
      <ModalContent overflow='hidden'>
        {(title || headerExtra) && (
          <ModalHeader
            fontSize="lg"
            fontWeight="700"
            color="navy.800"
            borderBottom="1px solid"
            borderColor="secondaryGray.100"
            pr="48px"
          >
            <Flex align="center" justify="space-between" gap="16px">
              {title && <Box flexShrink={0}>{title}</Box>}
              {headerExtra && <Box flex="1">{headerExtra}</Box>}
            </Flex>
          </ModalHeader>
        )}
        <ModalCloseButton />
        
        <ModalBody py="24px">
          {children}
        </ModalBody>

        {!hideFooter && (
          <ModalFooter
            gap="10px"
            borderTop="1px solid"
            borderColor="secondaryGray.100"
            pt="14px"
            pb="16px"
            px="24px"
          >
            <Button
              flex="1"
              variant="outline"
              colorScheme="gray"
              borderRadius="10px"
              onClick={() => {
                if (onSecondaryClick) {
                  onSecondaryClick();
                } else {
                  onClose();
                }
              }}
              isDisabled={secondaryBtnDisabled}
              isLoading={secondaryBtnLoading}
              fontWeight="600"
              fontSize="sm"
            >
              {secondaryBtnLabel}
            </Button>
            <Button
              flex="1"
              bg="brand.500"
              color="white"
              _hover={{ bg: 'brand.600' }}
              borderRadius="10px"
              onClick={onPrimaryClick}
              isDisabled={primaryBtnDisabled}
              isLoading={primaryBtnLoading}
              fontWeight="600"
              fontSize="sm"
            >
              {primaryBtnLabel}
            </Button>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
}